export default function(can, cannot) {
  // property
  cannot('view', 'Property');
  can('edit', 'Property');
  can('add', 'Property');
  can('bulk-edit-fully', 'Property');
  can('bulk-edit', 'Property');
  can('list', 'Property');
  // repair content of property
  can('list', 'PropertyRepairContent');
  can('edit', 'PropertyRepairContent');
  can('view', 'PropertyRepairContent');
  
  // repair content
  can('view-menu', 'RepairContent');
  can('view', 'RepairContent');
  can('edit', 'RepairContent');
  can('add', 'RepairContent');
  can('list', 'RepairContent');

  // Floor Plan
  can('view', 'FloorPlan');
  can('edit', 'FloorPlan');
  can('add', 'FloorPlan');
  can('list', 'FloorPlan');

  // company
  can('view-info', 'Company');
  // moveout follow
  can('move-out-follow', 'ContractMoving');
  can('go-back-to-correct-check-list', 'ContractMoving');
  can('repair-request', 'ContractMoving');
  // partner
  can('view', 'Partner');
  can('add', 'Partner');
  can('edit', 'Partner');
  can('list', 'Partner');
  can('link', 'Partner');
  can('self-link', 'Partner'); // button link with role manage

  // account
  can('view', 'Account');
  can('add', 'Account');
  can('edit', 'Account');
  can('list', 'Account');
  can('link', 'Account');

  // contract
  can('view', 'Contract');
  can('edit', 'Contract');
  can('add', 'Contract');
  can('list', 'Contract');
  can('move-out', 'Contract');
  // contract moving
  can('view', 'ContractMoving');
  can('edit', 'ContractMoving');
  can('add', 'ContractMoving');
  can('list', 'ContractMoving');
  can('resign', 'ContractMoving');
  can('approval-correct-checklist', 'ContractMoving');
  can('approval-report-repair', 'ContractMoving');

  // Dashboard
  can('view', 'Dashboard');

  // MyPage
  can('view', 'MyPage');

  // MyPage
  can('list', 'Message');

  // side bar
  can('view-menu', 'Dashboard');
  can('view-menu', 'Company');
  can('view-menu', 'Property');
  can('view-menu', 'Contract');
  can('view-menu', 'RepairContent');
  can('view-menu', 'Partner');
  can('view-menu', 'Account');
  can('view-menu', 'FloorPlan');
  can('view-menu', 'TalkRoom');
  can('view-menu', 'ContractMoving');
}